// @feature-spec brain/vidmax/feature-specs/admin-kev.md
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { AdminKevRoute } from "./-KevPage"

const adminKevSearchSchema = z.object({ preset: z.string().optional() }).partial()

export const Route = createFileRoute("/admin/kev" as any)({
  validateSearch: adminKevSearchSchema,
  component: AdminKevRoute,
})
